import React from 'react';
import { mergeEmrSettings } from '../config/emrSettings';

const STORAGE_KEY = 'hcen_active_workspace';

/** Switch between clinic workspaces / branches */
export default function WorkspaceSwitcher({ emrSettings, collapsed }) {
  const settings = mergeEmrSettings(emrSettings);
  const workspaces = settings.workspaces?.length
    ? settings.workspaces
    : [{ id: 'main', name: 'Main clinic' }];

  const [active, setActive] = React.useState(() => localStorage.getItem(STORAGE_KEY) || workspaces[0]?.id || 'main');

  if (workspaces.length <= 1) return null;

  const onChange = (e) => {
    const id = e.target.value;
    setActive(id);
    localStorage.setItem(STORAGE_KEY, id);
    window.dispatchEvent(new CustomEvent('hcen-workspace-change', { detail: id }));
  };

  return (
    <div className="workspace-switcher" style={{ padding: collapsed ? '8px 6px' : '8px 14px' }}>
      {!collapsed && <label className="hint" style={{ fontSize: 10, display: 'block', marginBottom: 4 }}>Workspace</label>}
      <select className="input input-sm" value={active} onChange={onChange} title="Switch workspace">
        {workspaces.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
      </select>
    </div>
  );
}

export function getActiveWorkspaceId() {
  return localStorage.getItem(STORAGE_KEY) || 'main';
}
